// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually
import React from 'react';

const IconArrowRight = (props: React.SVGProps<SVGElement>) =>
  /*#__PURE__*/ React.createElement(
    'svg',
    {
      width: '1em',
      height: '1em',
      viewBox: '0 0 24 24',
      xmlns: 'http://www.w3.org/2000/svg',
      ...props
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289Z',
      fill: 'current'
    })
  );

export { IconArrowRight };
